var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgBlogHomeHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 534 489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#19f59b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fleck_Blog_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.76,66.7c-14.19,19.58-24,42.92-43.47,57.65-48,36.39-158.29-6.87-199.51,36.92-53.58,56.93,9.63,87,33.49,117.21,25.11,31.81,36.11,49.8,26.79,87.07-6.7,26.79-28.47,40.18-13.82,72.19,7.78,17,36.69,34.62,55.12,39.44,47.7,12.46,91.21,7.59,139.54-2.28s94.43-39.26,113.69-83.43c9.54-21.91,12.23-46.34,23.24-67.59C424.14,282.74,471.89,261.35,501,225c39.78-49.66,46.36-159.24-14.33-198.48C420.17-16.47,312.93,4.39,267.76,66.7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlogHomeHeader);
export default __webpack_public_path__ + "static/media/bg_blog_home_header.ebc6543dcddf463c5d04b0ca5c4400c6.svg";
export { ForwardRef as ReactComponent };